import { DeepBluex, White } from "@bonusx-global/bx-design-system";
import { AngleRightSmallOutlined, TimesSolid } from "@bonusx-global/bx-icons";
import { useMediaQuery, useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { AiChatbotIconContainer } from "../../../../components/Chatbot/components/ai-chatbot-icon-container/ai-chatbot-icon-container";
import { AiChatbotIcon } from "../../../../components/Chatbot/components/ai-chatbot-icon/ai-chatbot-icon";
import { CHATBOT_NAME } from "../../../../../features/ai-chatbot/constants/chatbot-name.const";

interface DrawerHeaderProps {
  onClose: () => void;
}

export function DrawerHeader(props: Readonly<DrawerHeaderProps>) {
  const { onClose } = props;
  const theme = useTheme();
  const isBreakpointMediumUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box sx={{ position: "sticky", top: 0 }}>
      <AppBar position="static" color="transparent" elevation={0} sx={{ backgroundColor: White.main }}>
        <Toolbar sx={{ gap: 2 }}>
          <AiChatbotIconContainer>
            <AiChatbotIcon />
          </AiChatbotIconContainer>
          <strong
            style={{
              fontWeight: 700,
              fontFamily: "DM Sans",
              fontSize: "16px",
              lineHeight: "21px",
              letterSpacing: "0.15px",
              fontFeatureSettings: "liga off, clig off",
              fontStyle: "normal",
            }}
          >
            {CHATBOT_NAME}
          </strong>
          <IconButton sx={{ marginLeft: "auto" }} onClick={onClose}>
            {isBreakpointMediumUp ? <AngleRightSmallOutlined /> : <TimesSolid />}
          </IconButton>
        </Toolbar>
      </AppBar>
      <Divider sx={{ borderColor: DeepBluex[100] }} />
    </Box>
  );
}
